export default {
	async addNewTeam(context, payload) {
		const token = localStorage.getItem('token');
		const userLeague = localStorage.getItem('leagueId');
		const userId = context.rootGetters.userId;
		const teamInfo = {
			team: payload.team,
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/users/${userId}.json?auth=` + token,
			{
				method: 'PATCH',
				body: JSON.stringify(teamInfo),
			}
		);
		const responseData = await response.json();
		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed to fetch teams.');
			throw error;
		}
		context.commit('setTeams', {
			team: responseData.team,
		});
		const response2 = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/leagues/${userLeague}/teams.json?auth=` + token,
			{
				method: 'POST',
				body: JSON.stringify(teamInfo),
			}
		);
		const responseData2 = await response2.json();
		if (!response.ok) {
			const error = new Error(responseData2.message || 'Failed to fetch leagues.');
			throw error;
		}
	},
	async addNewTeamManager(context, payload) {
		const token = localStorage.getItem('token');
		const userLeague = localStorage.getItem('leagueId');
		const divisionId = payload.divisionId;
		const teamInfo = {
			team: payload.team,
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/leagues/${userLeague}/divisions/${divisionId}/teams.json?auth=` +
				token,
			{
				method: 'POST',
				body: JSON.stringify(teamInfo),
			}
		);
		const responseData = await response.json();
		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed to fetch leagues.');
			throw error;
		}
	},
	async deleteTeam(context, payload) {
		const token = localStorage.getItem('token');
		const userLeagueId = localStorage.getItem('leagueId');
		const divisionId = payload.divisionId;
		const teamId = payload.id;

		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/leagues/${userLeagueId}/divisions/${divisionId}/teams/${teamId}.json?auth=` +
				token,
			{
				method: 'DELETE',
			}
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
		context.commit('deletedTeam', postId);
	},
	async fetchTeams(context, payload) {
		const token = localStorage.getItem('token');
		const userLeague = localStorage.getItem('leagueId');
		const divisionId = localStorage.getItem('divisionId');
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/leagues/${userLeague}/divisions/${divisionId}/teams.json?auth=` +
				token
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
		const teams = [];
		for (const key in responseData) {
			const team = {
				id: key,
				team: responseData[key].team,
				lineUp: responseData[key].lineup,
			};
			teams.push(team);
		}
		context.commit('setTeams', teams);
	},
	async fetchManagerTeams(context, payload) {
		const token = localStorage.getItem('token');
		const userLeague = localStorage.getItem('leagueId');
		const divisionId = payload.divisionId;
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/leagues/${userLeague}/divisions/${divisionId}/teams.json?auth=` +
				token
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
		const teams = [];
		for (const key in responseData) {
			const team = {
				id: key,
				team: responseData[key].team,
			};
			teams.push(team);
		}
		context.commit('setTeams', teams);
	},
	async addNewLineUp(context, payload) {
		const token = localStorage.getItem('token');
		const userType = localStorage.getItem('userType')
		const userLeague = localStorage.getItem('leagueId');
		const divisionId = localStorage.getItem('divisionId');
		const teamId = payload.teamId;
		const lineup = {
			battingOrder: payload.battingOrder,
			positionOrder: payload.positionOrder,
			season: payload.season,
			game: payload.game
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/leagues/${userLeague}/divisions/${divisionId}/teams/${teamId}/lineup.json?auth=` +
				token,
			{
				method: 'POST',
				body: JSON.stringify(lineup),
			}
		);
		const responseData = await response.json();
		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed to fetch leagues.');
			throw error;
		}
	},
	async fetchLineUp(context, payload) {
		const token = localStorage.getItem('token');
		const userLeague = localStorage.getItem('leagueId');
		const divisionId = localStorage.getItem('divisionId');
		const teamId = payload.teamId;
		
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/leagues/${userLeague}/divisions/${divisionId}/teams/${teamId}/lineup.json?auth=` +
				token,
			{
				method: 'GET',
			}
		);
		const responseData = await response.json();
		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed to fetch leagues.');
			throw error;
		}
		const lineUps = []
		for (const key in responseData) {
			const line = {
				id: key,
				battingOrder: responseData[key].battingOrder,
				positionOrder: responseData[key].positionOrder,
				season: responseData[key].season,
				game: responseData[key].game
			}
			lineUps.push(line)
		}
		context.commit('setLineUps', lineUps)
	},
};
